"use client";

import { useGetNotification } from "@/fetcher";
import { useNavigation } from "@/hooks/useNavigation";
import React from "react";
import { useIsLogging } from "@/hooks/useIsLogging";
import { CustomImage } from "../Image/CustomImage";

export const MainHeader = () => {
  const { navigationTo } = useNavigation();
  const { data } = useGetNotification();
  const { isLogging } = useIsLogging();

  return (
    <div className="w-full h-[50px] px-[20px] flex items-center bg-[#FAF7F4]">
      <CustomImage width={62.7} height={13.65} src="/assets/symbol.svg" alt="LOGO" placeholder="empty" />
      <div className="ml-auto flex gap-[16px]">
        <CustomImage
          width={24}
          height={24}
          src="/assets/search.svg"
          onClick={() => navigationTo("SEARCH")}
          alt="SEARCH"
          placeholder="empty"
          className="cursor-pointer"
        />
        <div className="relative">
          <CustomImage
            width={24}
            height={24}
            onClick={() => navigationTo("NOTIFICATION")}
            src="/assets/bell.svg"
            alt="BELL"
            placeholder="empty"
            className="cursor-pointer"
          />
          {isLogging ? data?.notificationList?.filter((i) => !i.notificationRead).length !==
            0 && (
            <div className="w-[8px] h-[8px] rounded-full bg-[#E00000] absolute top-0 right-[3px]" />
          ) : <div></div>}
        </div>
      </div>
    </div>
  );
};
